export function getPrimaryCampaignView(campaignType) {
  return campaignType === 'quest_loop' ? 'player' : 'dm';
}

export function buildPrimaryCampaignRoute(campaignId, campaignType) {
  if (!campaignId) {
    return null;
  }
  return `/${campaignId}/${getPrimaryCampaignView(campaignType)}`;
}
